import { useEffect, useState } from 'react';
import { Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';
import { Link } from 'react-router-dom';
import { settingsApi } from '../../lib/cms';

export const Footer = () => {
  const [links, setLinks] = useState<{ label: string, url: string }[]>([
    { label: "Polityka Prywatności", url: "/aktualnosci/polityka-prywatnosci" },
    { label: "Regulamin Serwisu", url: "/aktualnosci/regulamin-serwisu" }
  ]);

  useEffect(() => {
    settingsApi.get().then(s => {
      if (s.footer_links) {
        try {
          setLinks(JSON.parse(s.footer_links));
        } catch (e) { }
      }
    }).catch(console.error);
  }, []);

  return (
    <footer className="relative z-10 bg-surface border-t border-border py-12 md:py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">

          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <Link to="/">
                <img
                  src="https://web.archive.org/web/20190825223023im_/https://akademia-milionerow.pl/wp-content/uploads/logo-am-w260-fw.png"
                  alt="Akademia Milionerów"
                  className="h-10 w-auto object-contain opacity-80 hover:opacity-100 transition-opacity cursor-pointer"
                  referrerPolicy="no-referrer"
                />
              </Link>
            </div>
            <p className="text-text-muted text-sm leading-relaxed">
              Tworzymy przyszłość edukacji biznesowej. Łączymy technologię z ambicją, dając Ci narzędzia do budowania wolności.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-text-main mb-6">Platforma</h4>
            <ul className="space-y-4 text-sm text-text-muted">
              <li><a href="#" className="hover:text-primary transition-colors">Ścieżki Kariery</a></li>
              <li><Link to="/dolacz" className="hover:text-primary transition-colors">Cennik</Link></li>
              <li><Link to="/zaloguj" className="hover:text-primary transition-colors">Logowanie</Link></li>
              <li><Link to="/rejestracja" className="hover:text-primary transition-colors">Rejestracja</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-text-main mb-6 uppercase tracking-widest text-xs">Firma</h4>
            <ul className="space-y-4 text-sm text-text-muted">
              <li><Link to="/" className="hover:text-primary transition-colors">Strona Główna</Link></li>
              <li><Link to="/blog" className="hover:text-primary transition-colors">Blog</Link></li>
              <li><a href="#contact" className="hover:text-primary transition-colors">Kontakt</a></li>
              <li><a href="#" className="hover:text-primary transition-colors">Kariera</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-text-main mb-6">Social Media</h4>
            <div className="flex gap-4">
              <a href="#" className="p-2 bg-background border border-border rounded-full text-text-muted hover:text-primary hover:border-primary transition-all">
                <Facebook size={20} />
              </a>
              <a href="#" className="p-2 bg-background border border-border rounded-full text-text-muted hover:text-primary hover:border-primary transition-all">
                <Instagram size={20} />
              </a>
              <a href="#" className="p-2 bg-background border border-border rounded-full text-text-muted hover:text-primary hover:border-primary transition-all">
                <Twitter size={20} />
              </a>
              <a href="#" className="p-2 bg-background border border-border rounded-full text-text-muted hover:text-primary hover:border-primary transition-all">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

        </div>

        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-text-muted">
          <p>&copy; {new Date().getFullYear()} Akademia Milionerów. Wszelkie prawa zastrzeżone.</p>
          <div className="flex gap-6">
            {links.map((link, idx) => (
              <Link key={idx} to={link.url} className="hover:text-text-main">{link.label}</Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};
